<template>
  <div class="profession-card">
    <div class="profession-card-header">
      <h3 class="profession-card__title">
        Совместимость
      </h3>
      <h1 class="profession-card-header__percent">
        {{ percent }}<span class="profession-card-header__percent-item">%</span>
      </h1>
    </div>
    <div class="profession-card-body">
      <ul class="profession-card-body__list">
        <li
          v-for="(prof, index) in profession"
          :key="index"
          class="profession-card-body__item"
        >
          <span class="profession-card-body__item-text">
            {{ prof }}
          </span>
        </li>
      </ul>
    </div>
    <div class="profession-card-footer">
      <h3 class="profession-card__title">Экзамены для поступления</h3>
      <ul class="profession-card-footer__list">
        <li
          v-for="(subject, index) in exam"
          :key="index"
          class="profession-card-footer__item"
        >
          <component
            :is="icons[subject]"
            v-if="exam"
          />
          {{ subject }}
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import IconMath from '../Icons/IconMath';
import IconEnglish from '../Icons/IconEnglish';
import IconBiology from '../Icons/IconBiology';
import IconHistory from '../Icons/IconHistory';
import IconRussian from '../Icons/IconRussian';
import IconPhysics from '../Icons/IconPhysics';
import IconChemistry from '../Icons/IconChemistry';
import IconLiterature from '../Icons/IconLiterature';
import IconSocialStudies from '../Icons/IconSocialStudies';
import IconComputerScience from '../Icons/IconComputerScience';

export default {
  name: 'ProfessionCard',
  components: {
    IconMath,
    IconEnglish,
    IconBiology,
    IconHistory,
    IconRussian,
    IconPhysics,
    IconChemistry,
    IconLiterature,
    IconSocialStudies,
    IconComputerScience,
  },
  props: {
    profession: {
      type: Array,
      required: true,
    },
    exam: {
      type: Array,
      required: true,
    },
    percent: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      icons: {
        Физика: IconPhysics,
        Химия: IconChemistry,
        Русский: IconRussian,
        История: IconHistory,
        Математика: IconMath,
        Биология: IconBiology,
        Английский: IconEnglish,
        Литература: IconLiterature,
        Обществознание: IconSocialStudies,
        Информатика: IconComputerScience,
      },
    };
  },
};
</script>

<style lang="scss" scoped>
  .profession-card {
    width: 360px;
    background: #FFFFFF;
    border: 1px solid #DBDBDB;
    box-sizing: border-box;
    box-shadow: 0 4px 14px rgba(70, 97, 138, 0.2);
    border-radius: 8px;
    padding: 24px;
    &__title {
      font-size: 23px;
    }
    &-header {
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      align-items: center;
      &__percent {
        color: #F46D0C;
        font-weight: 800 !important;
        font-size: 43px;
        margin: 0;
        &-item {
          font-size: 26px;
        }
      }
    }

    &-body {
      border-top: 1px solid #DBDBDB;

      &__list {
        list-style-type: none;
        padding: 0 0 0 15px;
      }

      &__item {
        &:before {
          content: "\2022";
          color: red;
          font-weight: bold;
          display: inline-block;
          width: 1em;
          margin: 15px 0 15px 0;
        }

        &-text {
          font-size: 17px;
          font-weight: bold;
        }
      }
    }

    &-footer {
      &__list {
        list-style-type: none;
        padding: 0;
      }

      &__item {
        display: flex;
        flex-direction: row;
        align-items: center;
        align-content: center;
      }
    }
  }

  @media screen and (max-width: 576px) {
    .profession-card {
      margin: 16px 0;
      width: 288px;
      &__title {
        font-size: 17px;
      }
      &-header{
        &__percent {
          font-size: 28px;
          &-item {
            font-size: 16px;
          }
        }
      }
    }
  }
</style>
